import {Component, OnInit} from '@angular/core';
import {ApplicationService, Page} from '../services/application.service';
import {Observable, ReplaySubject, Subject} from 'rxjs';
import {tap} from 'rxjs/operators';
import {ActivatedRoute, ActivatedRouteSnapshot} from '@angular/router';

@Component({
    selector: 'app-complete',
    templateUrl: './complete.component.html',
    styleUrls: ['./complete.component.scss'],
    standalone: false
})
export class CompleteComponent implements OnInit {
  currentPage: Page;
  firstPage: Page;
  text: string;
  title: string;
  loading = true;
  dataLoadCount = 0;

  constructor(public application: ApplicationService, public route: ActivatedRoute) {
  }

  ngOnInit(): void {
    this.application.pages.pipe(
      tap(pages => {
        this.currentPage = pages.find(x => x.item === this.route.routeConfig.path);
        this.application.activePage.next(this.currentPage.item);
        this.firstPage = pages.find(p => p.order === 1);
        if (!this.currentPage.hasOwnProperty('getPrintUrl')) {
          this.loading = false;
        }
      })
    ).subscribe();
  }

  dataLoaded(e) {
    this.dataLoadCount += 1;
    if (this.dataLoadCount >= 2) {
      this.loading = false;
    }
  }
}
